import React from 'react';
import { SparklesIcon, PlusIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function PageHeader() {
  return <div className="flex flex-col sm:flex-row sm:items-center justify-between pb-6 border-b border-border mb-8" data-id="element-129">
      <div data-id="element-130">
        <h1 className="text-3xl font-bold tracking-tight text-foreground" data-id="element-131">
          Pick a Template
        </h1>
        <p className="text-muted-foreground mt-1" data-id="element-132">
          Just choose one and start building. No experience needed — seriously!
        </p>
      </div>
      <div className="flex items-center gap-3 mt-4 sm:mt-0" data-id="element-133">
        <Button variant="outline" className="gap-2 bg-background hover:bg-muted" data-id="element-134">
          <SparklesIcon className="w-4 h-4" data-id="element-135" />
          Let AI Help
        </Button>
        <Button className="gap-2 bg-[#f97316] hover:bg-[#ea580c] text-white border-none shadow-sm font-medium" data-id="element-136">
          <PlusIcon className="w-4 h-4" data-id="element-137" />
          Start Blank
        </Button>
      </div>
    </div>;
}